import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';
import { getRarityColor } from './RarirtyColorFactory';

export default class ItemIcon extends PureComponent {

    render() {
        const {image, rarity} = this.props;

        const rarityColor = getRarityColor(rarity);

        return <Image rounded={true}
                      src={`\\images\\${image}.png`}
                      bordered
                      style={{borderColor: rarityColor}}
                      {...this.props}
                />
    }
}

ItemIcon.propTypes = {
    image: PropTypes.string.isRequired,
    rarity: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/common/ItemIcon.jsx